import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ActionCreators from './../actions';
import Outreach from './../components/Outreach';

function mapDispatchToProps(dispatch) {
  return bindActionCreators(ActionCreators, dispatch);
}

function mapStateToProps(state) {
  return {
    outreach: state.Outreaches,
    business: state.business,
    auth:state.auth
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Outreach);
